// extracted by mini-css-extract-plugin
export default {"header":"NP-z","isActive":"OP-z"};